// import { useEffect, useRef,useCallback } from 'react';

// export const useDebounce=(callback:any, delay:any, immediate = false)=> {
//   const timerRef:any = useRef(); // 使用 useRef 保存定时器引用

//   const debouncedFn = useCallback(
//     (...args:any) => {
//       return function (this:any) {
//         const context:any = this; //eslint-disable-line
//         clearTimeout(timerRef.current);

//         if (immediate && !timerRef.current) {
//           callback.apply(context, args);
//           timerRef.current = null;
//         } else {
//           timerRef.current = setTimeout(() => {
//             callback.apply(context, args);
//           }, delay);
//         }
//       };
//     },
//     [callback, delay, immediate]
//   );

//   // 清理定时器
//   useEffect(() => {
//     return () => {
//       clearTimeout(timerRef.current);
//     };
//   }, []);

//   return debouncedFn;
// }

import { useEffect, useRef } from 'react';

export const useDebounce = (callback: () => void, delay=3000) => {
  const timerRef:any = useRef<number | null>(null);
  const lastExecTimeRef = useRef<number>(0);

  const debounced = () => {
    const now = Date.now();
    const timeSinceLastExec = now - lastExecTimeRef.current;

    if (timeSinceLastExec < delay) {
      // 如果距离上次执行时间小于延迟时间，则不执行
      return;
    }

    // 立即执行回调函数
    callback();
    lastExecTimeRef.current = now;

    // 防止重复点击，设置定时器
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      lastExecTimeRef.current = 0; // 重置上次执行时间
    }, delay);
  };

  return debounced;
};

